module.exports = __webpack_public_path__ + "static/img/ic_down02.bad49dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/ic_down02.svg
// module id = hvOF
// module chunks = 10